import React from 'react'
import HFCard from '../../../components/HFCard'
import { DemoButton, ResetButton } from './Button'
import { DemoCardProps } from './types'

const DemoCard = ({ headerText, demos, triggerDemo, sendTbrItems }: DemoCardProps) => {
  return (
    <HFCard headerText={headerText}>
      <div className="card-body">
        {demos.map(({ demo, isReset, buttonText, features }, index) => (
          <React.Fragment key={demo}>
            <div className="flex justify-between mb-4">
              <div>
                {isReset ? (
                  <ResetButton onClick={() => triggerDemo(demo)} variant="contained">
                    {buttonText}
                  </ResetButton>
                ) : (
                  <DemoButton onClick={() =>
                    demo === 'sendTbrItems' && sendTbrItems ?
                      sendTbrItems()
                      : triggerDemo(demo)
                  } variant="contained">
                    {buttonText}
                  </DemoButton>
                )}
              </div>
              <div>
                <ul>
                  {features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
            {index < demos.length - 1 && <hr />}
          </React.Fragment>
        ))}
      </div>
    </HFCard>
  )
}

export default DemoCard
